import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";
import { getPrismToken } from "../orderDetails";
/*
    TODO Write a network layer before axios,
    Handle cancellation of network call or ignoring stale response
    Camelize all api keys at deep level
*/

const graphqlService = axios.create({
  baseURL: constants.graphqlServiceUrl,
});

graphqlService.interceptors.request.use(async (config) => {
  try {
    // Get Prism token for GraphQL API
    const prismToken = await getPrismToken();

    if (prismToken) {
      config.headers["Content-Type"] = "application/json";
      config.headers["Authorization"] = `Bearer ${prismToken}`;
      config.headers["apollographql-client-name"] = "prism-cms";
      config.headers["apollographql-client-version"] = "1.0";
      config.headers["role"] = "manager";
    }
  } catch (error) {
    console.error("Error getting Prism token for GraphQL request:", error);
  }

  return config;
});

graphqlService.interceptors.response.use(function (response) {
  return response;
}, errorHandler);

export default graphqlService;
